const LangMyRewards = {
	"myRewards._title": ["MY REWARDS", "QUÀ THƯỞNG CỦA TÔI"],
	"myRewards.header._validUntil": ["VALIDITY UNTIL", "NGÀY HẾT HẠN"],
	"myRewards.header._rewards": ["REWARDS", "QUÀ THƯỞNG"],
	"myRewards.header._to": ["To", "Đến"],
	"myRewards.body._noAvailableRecord": [
		"You don't have any earned Rewards at the moment.",
		"Tài khoản của bạn hiện chưa có quà thưởng.",
	],
}

export default LangMyRewards



// WEBPACK FOOTER //
// ./src/resources/modules/LangMyRewards.js